module.exports = __webpack_public_path__ + "static/media/status-M.9ce9b589.svg";